<template>
  <v-dialog 
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card>
      <v-card-title class="d-flex justify-content-center">Animais do Serviço Nº {{service.code}}</v-card-title>
      <v-card-text>
        <div class="col-md-12">
          <the-table 
            :dataItems="service.animals"
            :headers="headersForTable"
          >
            <template v-slot:situation="{item}">
              <span class="d-flex justify-content-center">{{item.status ? item.status.description + " - " + item.status.title : "-"}}</span>
            </template>
          </the-table>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TheTable from "@/components/layout/TheTable";

export default {
  name:"ModalAnimals",
  props: {
    active:Boolean,
    service:Object
  }, 
  components: {
    TheTable
  },
  data() {
    return {
      headersForTable:[
        {text:"Registro", value:"register", sortable:true},
        {text:"Situação", value:"situation", has_slot:true, header_slot:"situationHeader", sortable:true},
        {text:"Animal", value:"name", sortable:true},
        {text:"Brinco", value:"bottom", sortable:true},
        {text:"Composição Racial", value:"degree_blood", sortable:true},
      ]
    }
  }
}
</script>

<style>

</style>